// LiveDemo.js

import React from 'react';
import ImageReceiver from './ImageReceiver';

const LiveDemo = () => {
  return (
    <div>
      <h1>Live Demo Page</h1>
      <ImageReceiver />
    </div>
  );
}

export default LiveDemo;